import Icon from "@/atoms/Icon/Icon";
import Tooltip from "@/atoms/Tooltip/Tooltip";
import type { DefaultComponentProps } from "@/types/component.types";
import cn from "@/utils/cn";
import styles from "./PriceRow.module.css";

interface PriceRowProps extends DefaultComponentProps {
    readonly term: string;
    readonly asterisk?: string;
    readonly details: string;
    readonly tooltipContent?: string;
    readonly tooltipId?: string;
    readonly variant?: "bold" | "discount";
    readonly className?: string;
}

function PriceRow({
    asterisk,
    className,
    details,
    term,
    testId = "price-row",
    tooltipContent,
    tooltipId,
    variant,
}: PriceRowProps) {
    return (
        <dl
            className={cn(
                styles.container,
                variant && styles[variant],
                className
            )}
            data-testid={testId}
        >
            <dt className={styles.term} data-testid={`${testId}-term`}>
                {term}
                {tooltipContent && tooltipId ? (
                    <Tooltip content={tooltipContent} id={tooltipId}>
                        <Icon
                            className={styles.tooltipIcon}
                            name="circleInfo"
                        />
                    </Tooltip>
                ) : null}
                {asterisk}
            </dt>
            <dd data-testid={`${testId}-details`}>{details}</dd>
        </dl>
    );
}

export default PriceRow;
